<template>
    <div>
        <v-flex xs12 md6>
            <inputIcon
                v-model="search_employee"
                class="layout row search--no-border icon-clickable"
                icon_name="search"
                :placeholder="`${$t('Найти сотрудника')}...`"
                @icon:click="update_search_input(search_employee)"
            />
        </v-flex>
        <v-layout mt-4 wrap align-center>
            <v-layout column class="filter__layout">
                <v-flex
                    xs12
                    md5
                    :class="{
                        'mr-4': $vuetify.breakpoint.mdAndUp,
                        'mt-4': $vuetify.breakpoint.smAndDown
                    }"
                >
                    <div class="grey-text mb-2">{{ $t("Организации") }}</div>

                    <AutocompleteWithSelectAll
                        :key="autocompleteKey"
                        :organizations="users_filters ? users_filters.organizations : []"
                        :model="organizations_filtered"
                        @update:model="organizations_filtered = $event"
                    />
                </v-flex>
                <v-flex xs12 md5 mt-4
                        :class="{
                            'mr-4': $vuetify.breakpoint.mdAndUp,
                            'mt-4': $vuetify.breakpoint.smAndDown
                        }"
                >
                    <div class="grey-text mb-2">{{ $t("Курс") }}</div>
                    <v-select
                        v-model="test_id_filtered"
                        solo
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        deletable-chips
                        :no-data-text="$t('Не найдено подходящих записей')"
                        append-icon=""
                        :items="users_filters ? users_filters.courses : []"
                        :label="$t('Все курсы')"
                        class="input"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
            </v-layout>
            <v-layout align-center class="filter__layout">
                <v-flex
                    xs12
                    md3
                    lg6
                    wrap

                    :class="{
                        'mr-4': $vuetify.breakpoint.mdAndUp,
                        'mt-4': $vuetify.breakpoint.smAndDown
                    }"
                >
                    <div class="grey-text mb-2">{{ $t("Дата назначения (от/до)") }}</div>
                    <v-layout>
                        <v-flex xs6>
                            <datepicker
                                v-model="appointment_date_from"
                                ref="appointment_date_from"
                                :placeholder="$t('01.01.2024')"
                            />
                        </v-flex>
                        <v-flex xs6 ml-1>
                            <datepicker
                                v-model="appointment_date_to"
                                ref="appointment_date_to"
                                :placeholder="$t('01.01.2024')"
                            />
                        </v-flex>
                    </v-layout>

                    <div class="grey-text mb-2 text-no-wrap mt-4">
                        {{ $t("Дата окончания обучения (от/до)") }}
                    </div>
                    <v-layout>
                        <v-flex xs6>
                            <datepicker
                                v-model="completion_date_from"
                                ref="completion_date_from"
                                :placeholder="$t('01.01.2025')"
                            />
                        </v-flex>
                        <v-flex xs6 ml-1>
                            <datepicker
                                v-model="completion_date_to"
                                ref="completion_date_to"
                                :placeholder="$t('01.01.2025')"
                            />
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex
                    xs12
                    md3
                    lg2

                    class="clear-filter__cust"
                    :class="{ 'clear-filter': $vuetify.breakpoint.smAndDown }"
                >
                    <button class="link link--red" @click.prevent="reset_filters()">
                        {{ $t("Сбросить фильтр") }}
                    </button>
                </v-flex>
            </v-layout>

        </v-layout>
        <v-layout
            justify-start
            mb-4
            :class="{
                'mt-3': $vuetify.breakpoint.mdAndUp,
                'mt-4': $vuetify.breakpoint.mdAndDown
            }"
        />

        <data-table
            :table="users_employees_table"
            :search="search_employee"
            type="employees"
            :filter="obj"
        />
        <v-layout
            v-if="users_pages"
            align-center
            wrap
            :class="{
                'px-3': $vuetify.breakpoint.xs,
                'mt-5 justify-space-between': $vuetify.breakpoint.mdAndUp
            }"
        >
            <v-flex md5 sm12 :class="{ 'mt-4': $vuetify.breakpoint.smAndDown }">
                <v-pagination
                    v-model="pagination"
                    :length="users_pages"
                    :total-visible="7"
                    prev-icon="arrow_back_ios"
                    next-icon="arrow_forward_ios"
                />
            </v-flex>
            <v-flex md4 sm12 :class="{ 'mt-4': $vuetify.breakpoint.smAndDown }">
                <v-select
                    v-model="paginationTitle"
                    :items="
                        $vuetify.breakpoint.mdAndUp
                            ? [
                                $t('Показывать по 10'),
                                $t('Показывать по 25'),
                                $t('Показывать по 50'),
                                $t('Показывать по 100')
                            ]
                            : [
                                $t('Показывать по 10'),
                                $t('Показывать по 25'),
                                $t('Показывать по 50')
                            ]
                    "
                    solo
                    append-icon=""
                    :no-data-text="$t('Не найдено подходящих записей')"
                    :label="$t('Показывать по 10')"
                    class="input"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import inputIcon from '@/components/ui/inputs/typed/input_icon';
import DataTable from './Training_management_table.vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import Datepicker from '@inputs/base/datepicker.vue';
import AutocompleteWithSelectAll from '@/components/ui/autocompletewithselectall/AutocompleteWithSelectAll.vue';

export default {
  components: {
    AutocompleteWithSelectAll,
    Datepicker,
    DataTable,
    inputIcon,
  },
  data() {
    return {
      paginationTitles: {
        '10' : 'Показывать по 10',
        '25' : 'Показывать по 25',
        '50' : 'Показывать по 50',
        '100': 'Показывать по 100',
      },
      obj: {
        page_size               : 25,
        page_num                : 1,
        organization            : '',
        test_id                 : '',
        appointment_date        : '',
        training_completion_date: '',
        name                    : '',
        dateAppointmentFrom     : '',
        dateAppointmentTo       : '',
        dateCompletionFrom      : '',
        dateCompletionTo        : '',
      },
      autocompleteKey: 0,
    };
  },
  computed: {
    appointment_date_from: {
      get() {
        return this.appointment_date_filter_from;
      },
      set($event) {
        this.appointment_date_filter_from = $event.target.value.split(' ')[0];
        this.obj.dateAppointmentFrom = this.appointment_date_filter_from;
        if (this.obj.dateAppointmentFrom !== '') {
          console.log('dateAppointmentFrom');
          this.get_completed_courses(this.obj);
        }
      },
    },
    appointment_date_to: {
      get() {
        return this.appointment_date_filter_to;
      },
      set($event) {
        this.appointment_date_filter_to = $event.target.value.split(' ')[0];
        this.obj.dateAppointmentTo = this.appointment_date_filter_to;

        if (this.obj.dateAppointmentTo !== '') {
          console.log('dateAppointmentTo');
          this.get_completed_courses(this.obj);
        }
      },
    },
    completion_date_from: {
      get() {
        return this.obj.dateCompletionFrom;
      },
      set($event) {
        this.obj.dateCompletionFrom = $event ? $event.target.value.split(' ')[0] : '';

        if (this.obj.dateCompletionFrom !== '') {
          console.log('completion_date_from');
          this.get_completed_courses(this.obj);
        }
      },
    },
    completion_date_to: {
      get() {
        return this.obj.dateCompletionTo;
      },
      set($event) {
        this.obj.dateCompletionTo = $event ? $event.target.value.split(' ')[0] : '';

        if (this.obj.dateCompletionTo !== '') {
          console.log('completion_date_from');
          this.get_completed_courses(this.obj);
        }
      },
    },
    paginationTitle: {
      get() {
        return this.paginationTitles[this.obj.page_size];
      },
      set($event) {
        const pagination = Number($event.slice(-3));
        this.obj.page_size = pagination;
        localStorage.setItem('paginationValueUsers', pagination);
        this.SHOW_NUMBER($event);
        this.get_completed_courses(this.obj);

        return this.paginationTitles[this.obj.page_size];
      },
    },
    ...mapGetters('learning_management/modals', ['add_training']),
    ...mapGetters('learning_management/employees', [
      'users_employees_table',
      'users_filters',
      'test_id_filter',
      'org_filter',
      'appointment_date_filter',
      'training_completion_date_filter',
      'users_pages',
      'page',
      'search_string',
    ]),
    pagination: {
      get() {
        return this.page;
      },
      set($event) {
        this.SET_PAGE($event);
        this.obj.page_num = $event;
        this.get_completed_courses(this.obj);
      },
    },
    search_employee: {
      get() {
        return this.search_string;
      },
      set($event) {
        return this.update_search_input($event.target.value);
      },
    },
    organizations_filtered: {
      get() {
        return this.org_filter || [];
      },
      set(value) {
        this.SET_ORG_FILTER(value);
        this.obj.organization = value;
        this.get_completed_courses(this.obj);
      },
    },
    test_id_filtered: {
      get() {
        return this.test_id_filter;
      },
      set(value) {
        this.SET_TEST_ID_FILTER(value);
        this.obj.test_id = value;
        this.get_completed_courses(this.obj);
      },
    },
    appointment_date_filtered: {
      get() {
        return this.appointment_date_filter;
      },
      set($event) {
        const value = $event.target.value.split(' ')[0];

        this.SET_APPOINTMENT_DATE_FILTER(value);
        this.obj.appointment_date = value;
        this.get_completed_courses(this.obj);
      },
    },
    training_completion_date_filtered: {
      get() {
        return this.training_completion_date_filter;
      },
      set($event) {
        const value = $event.target.value.split(' ')[0];

        this.SET_TRAINING_COMPLETION_DATE_FILTER(value);
        this.obj.training_completion_date = value;
        this.get_completed_courses(this.obj);
      },
    },
  },
  async mounted() {
    this.obj.page_size = localStorage.getItem('paginationValueUsers') || 10;
    await this.update_completed_courses(
        Object.assign(this.obj, {organization: this.$route.query.filter_org})
    );
  },
  methods: {
    ...mapMutations('learning_management/employees', [
      'SET_PAGE',
      'SHOW_NUMBER',
      'SEARCH_EMPLOYEE',
      'SET_ORG_FILTER',
      'SET_TRAINING_COMPLETION_DATE_FILTER',
      'SET_APPOINTMENT_DATE_FILTER',
      'SET_TEST_ID_FILTER',
      'RESET_EMPLOYEES_FILTERES',
    ]),
    ...mapActions('learning_management/employees', [
      'get_completed_courses',
      'update_completed_courses',
    ]),

    update_search_input(value) {
      this.SEARCH_EMPLOYEE(value);
      this.obj.name = value;
      this.obj.organization = this.organizations_filtered;

      this.get_completed_courses(this.obj);
    },
    reset_filters() {
      this.$router.replace({name: 'training_management'});

      this.obj.organization = ''; // Очищаем значение
      this.obj.test_id = '';
      this.obj.appointment_date = '';
      this.obj.training_completion_date = '';

      this.$refs.appointment_date_from.clear_calendar();
      this.$refs.appointment_date_to.clear_calendar();
      this.$refs.completion_date_from.clear_calendar();
      this.$refs.completion_date_to.clear_calendar();

      this.RESET_EMPLOYEES_FILTERES();
      this.update_search_input('');

      this.autocompleteKey++; // Меняем ключ, чтобы Vue пересоздал компонент
    },


  },
};
</script>

<style lang="less">
@import url("../../../less/variables");

.clear-filter {
  order: -1;

    &__cust {
        margin-top: 2.5rem ;
    }
}


.v-select .v-input__icon .v-icon.material-icons {
  font-size: 1.75rem;
  width: 1.75rem;
  height: 1.75rem;
  color: @main-color;

  &:hover {
    color: @font-color;
  }

  .v-list__tile__action {
    min-width: 2.5rem;
  }
}

.filter__layout {
    width: 50%;
}
</style>

